"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxRenderColumns = exports.getGridItemResponsiveWidth = void 0;
var _themeProvider = require("@gravity/theme-provider");
function cov_ebce40f3d() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/helper.js";
  var hash = "4789aac7816774001c8756e3bad59e7a9a063b65";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/helper.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 42
        },
        end: {
          line: 14,
          column: 78
        }
      },
      "1": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 78
        }
      },
      "2": {
        start: {
          line: 22,
          column: 35
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "3": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "4": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 15
        }
      },
      "5": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "6": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 58
        }
      },
      "7": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 42
          },
          end: {
            line: 13,
            column: 43
          }
        },
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 78
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 35
          },
          end: {
            line: 22,
            column: 36
          }
        },
        loc: {
          start: {
            line: 22,
            column: 93
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 53
          },
          end: {
            line: 22,
            column: 88
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 22,
            column: 61
          },
          end: {
            line: 22,
            column: 88
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 25,
            column: 15
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 27,
            column: 57
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 14
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 58
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 32,
            column: 21
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 51
          },
          end: {
            line: 27,
            column: 52
          }
        }, {
          start: {
            line: 27,
            column: 55
          },
          end: {
            line: 27,
            column: 56
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 35
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 51
          },
          end: {
            line: 30,
            column: 52
          }
        }, {
          start: {
            line: 30,
            column: 55
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4789aac7816774001c8756e3bad59e7a9a063b65"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ebce40f3d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ebce40f3d();
/* eslint-disable import/prefer-default-export */
/**
 * Calculates the responsive width for a box within a grid layout.
 *
 * @param {number} numberOfColumns - The number of columns in the grid layout.
 * @param {number} spacing - The spacing between the boxes.
 * @param {boolean} isDesktop
 * @returns {string} The CSS width value for a box.
 */
cov_ebce40f3d().s[0]++;
var getGridItemResponsiveWidth = exports.getGridItemResponsiveWidth = function getGridItemResponsiveWidth(numberOfColumns, spacing) {
  cov_ebce40f3d().f[0]++;
  cov_ebce40f3d().s[1]++;
  return "calc(100% / ".concat(numberOfColumns, " - ").concat(spacing * (1 - 1 / numberOfColumns), "px)");
};

/**
 * Get the maximum number of columns to render based on the screen size.
 * @param {number} columns - The total number of columns.
 * @param {string} screen - The screen size ('sm' for small, 'md' for medium, etc.).
 * @returns {number} The maximum number of columns to render.
 */
cov_ebce40f3d().s[2]++;
var getMaxRenderColumns = exports.getMaxRenderColumns = function getMaxRenderColumns(columns, screen) {
  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_ebce40f3d().b[0][0]++, _themeProvider.TicketShopTheme.EQUILIBRIUM);
  cov_ebce40f3d().f[1]++;
  cov_ebce40f3d().s[3]++;
  switch (screen) {
    case 'xs':
      cov_ebce40f3d().b[1][0]++;
      cov_ebce40f3d().s[4]++;
      return 1;
    case 'sm':
      cov_ebce40f3d().b[1][1]++;
      cov_ebce40f3d().s[5]++;
      return theme === _themeProvider.TicketShopTheme.EVOLUTION ? (cov_ebce40f3d().b[2][0]++, 1) : (cov_ebce40f3d().b[2][1]++, 2);
    case 'md':
      cov_ebce40f3d().b[1][2]++;
    case 'lg':
      cov_ebce40f3d().b[1][3]++;
      cov_ebce40f3d().s[6]++;
      return Math.max(columns - 2, columns === 5 ? (cov_ebce40f3d().b[3][0]++, 4) : (cov_ebce40f3d().b[3][1]++, 3));
    default:
      cov_ebce40f3d().b[1][4]++;
      cov_ebce40f3d().s[7]++;
      return columns;
  }
};